import { Component, ElementRef, input, output } from '@angular/core';
import { ApproveRejectRegService } from './approve-reject-reg.service';
import { MatIconModule } from '@angular/material/icon';
import { ApproveRejectRegViewModel } from './viewmodel/approve-reject-reg.viewmodel';
import { Router, RouterModule } from '@angular/router';
import { Uuid } from '../../domain/model/uuid/uuid.type';
import { RoutePaths } from '../../../app.routes';
import { ApprovalStatusViewModel } from '../../viewmodels/shared/approval-status.viewmodel';

export interface ApproveRejectRegClickEvent {
  actionType: ApproveRejectRegActionType;
  batchWeighingId: Uuid;
  sectionId: Uuid;
}

export enum ApproveRejectRegActionType {
  Approve = 'Approve',
  Reject = 'Reject',
}

@Component({
  selector: 'approve-reject-reg',
  imports: [MatIconModule, RouterModule],
  templateUrl: './approve-reject-reg.component.html',
  providers: [ApproveRejectRegService],
})
export class ApproveRejectRegComponent {
  click = output<ApproveRejectRegClickEvent>();
  viewModel = input.required<ApproveRejectRegViewModel>();

  constructor(
    private approveRejectRegService: ApproveRejectRegService,
    private router: Router,
    private doc: ElementRef
  ) {}

  isStatusCompleted(status: ApprovalStatusViewModel | null): boolean {
    if (status === null) {
      return false;
    }
    return status.status.status === 'Approved' || status.status.status === 'Rejected';
  }

  async clickBatchWeighing(batchWeighingId: Uuid) {
    await this.router.navigate([`/${RoutePaths.BATCH_WEIGHING}/${batchWeighingId.asString()}`]);
  }

  async clickReject() {
    const batchWeighingId: Uuid = this.viewModel().id;
    const sectionIdValue: Uuid = this.viewModel().sectionId;

    this.approveRejectRegService.rejectBatchInsertion(sectionIdValue, batchWeighingId);
    this.click.emit({ actionType: ApproveRejectRegActionType.Reject, batchWeighingId: batchWeighingId, sectionId: sectionIdValue });
  }

  async clickApprove() {
    const batchWeighingId: Uuid = this.viewModel().id;
    const sectionIdValue: Uuid = this.viewModel().sectionId;

    this.approveRejectRegService.approveBatchInsertion(sectionIdValue, batchWeighingId);
    this.click.emit({ actionType: ApproveRejectRegActionType.Approve, batchWeighingId: batchWeighingId, sectionId: sectionIdValue });
  }
}
